import { createContext } from "react";

export const QuantityDefinitionContext = createContext("");
